import { render, staticRenderFns } from "./CsatQuestion.vue?vue&type=template&id=4d3f0966&scoped=true&"
import script from "./CsatQuestion.vue?vue&type=script&lang=js&"
export * from "./CsatQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CsatQuestion.vue?vue&type=style&index=0&id=4d3f0966&prod&lang=scss&"
import style1 from "./CsatQuestion.vue?vue&type=style&index=1&id=4d3f0966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f0966",
  null
  
)

export default component.exports